<template>

    <base-radio-group
        :item-list="buildTemplateListForRadioSelector"
        :selected-value="selectedPdfTemplate"
        value-key="templateKey"
        label-key="templateName"
        @onChangeValue="selectedPdfTemplate = $event.newValue"
        :hide-details="true"
    ></base-radio-group>

</template>

<script>

import {mapGetters} from "vuex";
import BaseRadioGroup from "../BaseRadioGroup";

export default {
    name: "PdfTemplateSelectorRadioGroup",
    components: {BaseRadioGroup},
    props: [
        'selectedTemplate'
    ],

    computed: {
        ...mapGetters({
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),

        selectedPdfTemplate: {
            get() {
                return this.selectedTemplate;
            },
            set(newValue) {
                this.$emit('onChangeSelectedTemplate', {selectedPdfTemplate: newValue});
            },
        },

        findTemplateNameForDisplay() {
            return (template) => {
                return (this.text('pdf.template.name.' + template).length > 0)
                    ? this.text('pdf.template.name.' + template)
                    : template;
            };
        },

        buildTemplateListForRadioSelector() {
            return this.getAppPropertyValueArray('PDF_TEMPLATE').map((templateKey) => {
                return {
                    templateKey: templateKey,
                    templateName: this.findTemplateNameForDisplay(templateKey)
                };
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/shared/assessment-share/PdfTemplateSelectorRadioGroup.vue